import { IS_TEST_MODE } from 'constants/global';
import React from 'react';
import { IProps } from 'types/common';
import { useBoolean } from 'usehooks-ts';
import SupportBubble from './SupportBubble';
import ChatBubbleContext from './SupportBubbleContext';

const ChatBubbleProvider: React.FC<IProps> = ({ children }) => {
	const {
		value: shouldOpen,
		setTrue: open,
		setFalse: close
	} = useBoolean(false);
	const chatBubbleComponent = !IS_TEST_MODE && <SupportBubble />;

	const context = React.useMemo(
		() => ({
			shouldOpen,
			open,
			close
		}),
		[shouldOpen, open, close]
	);

	return (
		<ChatBubbleContext.Provider value={context}>
			{chatBubbleComponent}
			{children}
		</ChatBubbleContext.Provider>
	);
};

export default ChatBubbleProvider;
